<template>
  <div class="income-receivable-push">
    <div class="content-wrapper">
      <!-- 左侧项目树 -->
      <div class="tree-panel">
        <erp-tree @node-click="handleNodeClick"></erp-tree>
      </div>

      <!-- 右侧内容区 -->
      <div class="right-panel">
        <div v-if="filterData.pindex_id" class="selected-info">
          已选择：<strong>{{ filterData.house_address || '全部项目' }}</strong>
        </div>

        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="应收款数据" name="receivable">
            <ReceivableData ref="receivableData" :filter-data="filterData" />
          </el-tab-pane>

          <el-tab-pane label="每日收款数据" name="dailyPayment">
            <DailyPaymentData ref="dailyPaymentData" :filter-data="filterData" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ReceivableData from './ReceivableData.vue'
import DailyPaymentData from './DailyPaymentData.vue'

export default {
  name: 'IncomeReceivablePush',
  components: {
    ReceivableData,
    DailyPaymentData,
    "erp-tree": () => import('@/components/Admin/Common/erp-tree.vue')
  },
  data() {
    return {
      activeTab: 'receivable',
      filterData: {
        pindex_id: '',
        house_id: 0,
        house_address: ''
      }
    }
  },
  methods: {
    // 处理树节点点击
    handleNodeClick(data) {
      if (data.tree && data.tree.length > 0) {
        // 获取最后一个元素
        const treeData = data.tree[data.tree.length - 1];
        console.log(treeData)
        if (treeData.type === 'project') {
          // 选择了项目
          this.filterData.pindex_id = treeData.pindex_id;
          this.filterData.house_id = 0;
          this.filterData.house_address = treeData.name;

        } else if (treeData.type === 'room') {
          // 选择了房产
          this.filterData.house_id = treeData.id || treeData.house_id;
          this.filterData.house_address = treeData.ancestor_name;

          // 从tree中查找所属项目
          for (let i = 0; i < data.tree.length; i++) {
            if (data.tree[i].type === 'project') {
              this.filterData.pindex_id = data.tree[i].pindex_id;
              break;
            }
          }
        }

        // 通知子组件刷新数据
        this.refreshCurrentTab();
      }
    },

    // Tab切换处理
    handleTabClick(tab) {
      console.log('切换到Tab:', tab.name)
      // 切换Tab时刷新数据
      this.refreshCurrentTab();
    },

    // 刷新当前Tab的数据
    refreshCurrentTab() {
      if (this.activeTab === 'receivable' && this.$refs.receivableData) {
        this.$refs.receivableData.loadData();
      } else if (this.activeTab === 'dailyPayment' && this.$refs.dailyPaymentData) {
        this.$refs.dailyPaymentData.loadData();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.income-receivable-push {
  padding: 20px;
  height: calc(100vh - 100px);

  .content-wrapper {
    display: flex;
    gap: 20px;
    height: 100%;

    .tree-panel {
      width: 280px;
      flex-shrink: 0;
      background: #fff;
      border-radius: 4px;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      overflow-y: auto;
    }

    .right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0; // 防止内容溢出

      .selected-info {
        margin-bottom: 15px;
        padding: 10px 15px;
        background: #f5f7fa;
        border-radius: 4px;
        color: #606266;
        font-size: 14px;
      }

      ::v-deep .el-tabs {
        flex: 1;
        display: flex;
        flex-direction: column;

        .el-tabs__content {
          flex: 1;
          overflow: hidden;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/income/IncomeReceivablePush.vue